export const endPoint = {
    API_BASE_URL: "https://pomofocus-production.up.railway.app",
  };